
export default angular.module('mars.vet.dnareports.controllers.homepage',[]).controller('HomePageController',

    function($rootScope, $scope, $window, EntryService, ImageService, EntryIDService, NavigationService, reportdata) {
        'ngInject';
        var resultString = reportdata.resultString;
        var sampleDetails = reportdata.sampleDetails;

        $scope.type = 'success';
        $scope.message = '';

    var reportType = 'online';
    $scope.onloadFun = function() {
        reportType = 'pdf';
    }

    $scope.resultString  = resultString;
    $scope.sampleID = resultString.sampleID;
    EntryService.getEntry(EntryIDService.getEntryID('HomePage')).then(function(response) {
        $scope.flyoverMessage = 'It appears we have tested ' + sampleDetails.petDetails.petName + ' before! ';
        $scope.resultset = response.fields;

        if (reportType != 'pdf') {
            $rootScope.pageTitle = $scope.resultset.title.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
        }
        $scope.title = $scope.resultset.title.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
        $scope.description = $scope.resultset.description.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
        $scope.imgdescription = $scope.resultset.imageDescription.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
        $scope.geneticDescription = $scope.resultset.geneticDescription;
        $scope.snpString = resultString.snpString.substring(1, Math.min(750, resultString.snpString.length));
        var testimonial = $scope.resultset.testimonial;
        $scope.range = testimonial['STARS'];
        $scope.stars = [];

        for (var k = 1; k <= $scope.range; k++) {
            $scope.stars.push(k);
        }

        $scope.resultString  = resultString;
       
        EntryService.getEntry(EntryIDService.getEntryID('HomePage')).then(function(response) {
            $scope.flyoverMessage = 'It appears we have tested ' + sampleDetails.petDetails.petName + ' before! ';
            $scope.resultset = response.fields;

            if (reportType != 'pdf') {
                $rootScope.pageTitle = $scope.resultset.title.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
            }
            $scope.title = $scope.resultset.title.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
            $scope.description = $scope.resultset.description.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
            $scope.imgdescription = $scope.resultset.imageDescription.replaceAll('[BREED NAME]', sampleDetails.petDetails.petName);
            $scope.geneticDescription = $scope.resultset.geneticDescription;
            $scope.snpString = resultString.snpString.substring(1, Math.min(750, resultString.snpString.length));
            var testimonial = $scope.resultset.testimonial;
            $scope.range = testimonial['STARS'];
            $scope.stars = [];

            for (var k = 1; k <= $scope.range; k++) {
                $scope.stars.push(k);
            }

            var box1Parameters = testimonial['BOX1'].split('&');
            $scope.box1Title = box1Parameters[0];
            $scope.box1 = box1Parameters[1];
            $scope.box2 = testimonial['BOX2'];
            $scope.box3 = testimonial['BOX3'];
            ImageService.getImageUrl('4k2GdTv73O6ykOcYiyWceq').then(function(response) {
                $scope.homeImageUrl = response.data.fields.file.url;
            });
            ImageService.getImageUrl('61bcbQxfDagOewy8EGYYg').then(function(response) {
                $scope.starRating = response.data.fields.file.url;
            });
            NavigationService.setNavigationUrls();
            $window.ga('send', 'pageview', {
                'page': 'HomePage'
            });
        }, function(error) {
            // promise rejected, could log the error with:
            // console.log('error', error);
        });
    }, function(error) {
        // promise rejected, could log the error with:
        // console.log('error', error);
    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/homepage.controller.js